<template>
  <svg id="icon-stats" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-204.5-12.5h554v512h-554z"/>
      <path d="M15.6 11.3a.7.7 0 0 0 1.4 0V5.7a.7.7 0 0 0-.7-.7h-5.6a.7.7 0 0 0 0 1.4h3.913L10.7 10.313l-2.31-2.31a.7.7 0 0 0-.98 0l-4.2 4.2a.7.7 0 0 0 .98.994L7.9 9.48l2.31 2.31a.7.7 0 0 0 .98 0l4.41-4.41v3.92z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
